import { zIdName } from "src/types/ZIdName";
import { z } from "zod";

export const zMcSizeVersions = z.object({
  size: zIdName,
  versions: zIdName.array(),
});

export type ZMcSizeVersions = z.infer<typeof zMcSizeVersions>;
